<template>
    <CompassToggleButtonGroup
        :modelValue="activeFilter"
        exclusive
        @update:modelValue="handleChange"
    >
        <CompassToggleButton value="all" :label="$t.__('timeline.TimelineEmailFilters.all')" />
        <CompassToggleButton
            value="emailengine.received"
            :label="$t.__('timeline.TimelineEmailFilters.received')"
        />
        <CompassToggleButton
            value="emailengine.sent"
            :label="$t.__('timeline.TimelineEmailFilters.sended')"
        />
    </CompassToggleButtonGroup>
</template>
<script>
export default {
    props: {
        activeFilter: {
            type: Array,
            required: true,
        },
    },
    methods: {
        handleChange(value) {
            if (value !== '') {
                this.$emit('filterUpdate', [value]);
            }
        },
    },
};
</script>
